import React, { useState, useEffect } from 'react'
import Loader from '../../../presentationals/Loader/Loader.component'
import Pagination from '@mui/material/Pagination';
import moment from 'moment'
import { LineChart, Line, Cell, Pie, PieChart, BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getOEMDashboardcompleteDatabyDate, getOEMDashboardAssignmentDatabyDate, getOemDashboardDetailsByOeMId, DownloadOemDashboardList } from '../maketingComponents/actioncreator';
const size = 10;

export default function OEMDashboard({ admin }) {
    const [loader, setLoader] = useState(false)
    const [StatsData, setStatsData] = useState({})
    const [infoPopup, setInfoPopup] = useState({ show: false, data: {} })
    const [infoTableData, setInfoTableData] = useState({})

    const [dealersData, setdealersData] = useState([])
    const [dealersDataItems, setDealersDataItems] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)

    const [payload, setPayload] = useState({
        startDate: moment().startOf('year').format('YYYY-MM-DD'),
        endDate: moment(new Date()).format("YYYY-MM-DD"),
        productType: ""
    })

    const [PieData, setPieData] = useState([
        { name: "Assigned Dealers", value: 80 },
        { name: "Unassigned Dealers", value: 20 },
    ])
    const [vehicleTypeList, setvehicleTypeList] = useState([])
    const [salesOverTimeList, setsalesOverTimeList] = useState([])

    const handlechange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    useEffect(() => {
        APicall()
    }, [])

    const APicall = () => {
        setCurrentPage(0)
        getOEMDashboardAssignmentDatabyDateFn(0)
        getOEMDashboardcompleteDatabyDateFn()
    }

    const getOEMDashboardcompleteDatabyDateFn = () => {
        setLoader(true)
        getOEMDashboardcompleteDatabyDate(payload?.startDate, payload?.endDate, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setStatsData(callback?.data?.summary)
                setPieData([
                    { name: "Assigned Dealers", value: callback?.data?.dealerStatusBreakdown?.assignedPercentage },
                    { name: "Unassigned Dealers", value: callback?.data?.dealerStatusBreakdown?.unassignedPercentage },
                ])
                setvehicleTypeList(callback?.data?.vehicleTypeUsage)
                setsalesOverTimeList(callback?.data?.salesOverTime)
            } else {
                setStatsData({})
                setPieData([
                    { name: "Assigned Dealers", value: 0 },
                    { name: "Unassigned Dealers", value: 0 },
                ])
                setvehicleTypeList([])
                setsalesOverTimeList([])
            }
        })
    }

    const getOEMDashboardAssignmentDatabyDateFn = (page) => {
        setLoader(true)
        getOEMDashboardAssignmentDatabyDate(payload?.startDate, payload?.endDate, size, page, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setDealersDataItems(callback?.data?.totalPages)
                setdealersData(callback?.data?.data)
            } else {
                setDealersDataItems(0)
                setdealersData([])
            }
        })
    }

    const getOemDashboardDetailsByOeMIdFn = (id) => {
        setLoader(true)
        getOemDashboardDetailsByOeMId(id, payload?.productType, callback => {
            setLoader(false)
            if (callback?.status == 200) {
                setInfoTableData(callback?.data)
            } else {
                setInfoTableData({})
            }
        })
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value - 1);
        getOEMDashboardAssignmentDatabyDateFn(value - 1)
        // api call for table
    };

    const handleInfoPopup = (value, data) => {
        setInfoPopup({ show: value, data: data })
        getOemDashboardDetailsByOeMIdFn(data?.oemId)
    }


    const handleDownload = () => {
        setLoader(true)
        DownloadOemDashboardList(payload?.startDate, payload?.endDate, payload?.productType, callback => {
            setLoader(false)
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ''
            }
            <div className='dealerDashboard'>
                <div className='container-fluid' style={{ marginTop: '90px' }}>
                    <div className="row" >
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Start Date</label>
                            <input type='date' className='form-control' value={payload.startDate} onChange={(e) => handlechange(e, "startDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">End Date</label>
                            <input type='date' className='form-control' value={payload.endDate} onChange={(e) => handlechange(e, "endDate")} />
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <label htmlFor="">Vehicle type</label>
                            <select className='form-control' value={payload.productType} onChange={(e) => handlechange(e, "productType")}>
                                <option value="">Select Product</option>
                                <option value="Three Wheeler - L3">Three-Wheeler L3</option>
                                <option value="Three Wheeler - L5">Three-Wheeler L5</option>
                                <option value="BATTERY">BATTERY</option>

                            </select>
                        </div>
                        <div className="col-sm-2 col-xs-12">
                            <button style={{
                                marginTop: '24px', padding: '10px',
                                color: " rgb(43, 120, 255)",
                                border: "1px solid rgb(43, 120, 255)",
                                backgroundColor: "rgb(255, 255, 255)",
                                marginTop: "28px",
                                padding: "10px",
                                borderRadius: "5px"
                            }}
                                onClick={() => APicall()}>
                                Apply
                            </button>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xl-2 col-lg-4 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.totalOems ?? ""}</b></h3>
                                    <h6>Total OEMs</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.assignedOems ?? ""}</b></h3>
                                    <h6>Assigned OEM</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.unassignedOems ?? ""}</b></h3>
                                    <h6>Unassigned OEM</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#5a57b71a", padding: '19px 15px' }}>
                                    <svg width="24" height="26" viewBox="0 0 24 26" fill="#5B93FF1a" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.2205 0.0697543C1.72539 0.45946 0.973331 2.06719 1.64696 3.4338C2.34407 4.84819 4.26656 5.18825 5.40844 4.09918C6.66723 2.89869 6.246 0.779821 4.626 0.163523C4.23738 0.0156681 3.59299 -0.0273162 3.2205 0.0697543ZM11.406 0.0831905C10.7213 0.267084 10.1098 0.774014 9.81516 1.40198C9.6762 1.69821 9.66149 1.79214 9.66149 2.38425C9.66149 3.01421 9.66873 3.05344 9.85375 3.42168C10.752 5.2092 13.2944 5.17732 14.1526 3.36771C14.3223 3.00982 14.3355 2.939 14.3355 2.38425C14.3355 1.8304 14.3221 1.75833 14.1539 1.40369C13.8139 0.686622 13.1823 0.190053 12.4325 0.0502832C12.0283 -0.025039 11.7791 -0.0170683 11.406 0.0831905ZM19.614 0.0831905C18.9098 0.272322 18.3722 0.726532 18.051 1.40369C17.8827 1.75867 17.8695 1.83001 17.8695 2.38726C17.8695 2.96724 17.8769 3.00311 18.0841 3.42185C18.4441 4.14922 19.0591 4.59643 19.8688 4.71969C20.799 4.86134 21.7142 4.44402 22.2222 3.64662C22.6346 2.99924 22.6904 2.04959 22.3566 1.35524C21.8695 0.341666 20.6893 -0.205687 19.614 0.0831905ZM1.6115 5.6543C1.17471 5.76002 0.620216 6.05084 0.289845 6.34752L0 6.60781V7.4281V8.24833H3.7905H7.58099V7.45953V6.67072L7.27667 6.38327C6.92772 6.05363 6.44253 5.79105 5.94373 5.66193C5.49297 5.54527 2.08677 5.5393 1.6115 5.6543ZM9.80399 5.66238C9.35831 5.7795 8.84246 6.05175 8.50137 6.34973L8.20799 6.6061V7.42725V8.24833H12H15.792L15.7763 7.41096L15.7605 6.5736L15.4329 6.31005C15.0449 5.998 14.6113 5.77654 14.157 5.65834C13.6905 5.53696 10.2691 5.54015 9.80399 5.66238ZM18.0237 5.66113C17.5917 5.77728 17.1494 6.00654 16.7721 6.31005L16.4445 6.5736L16.4287 7.41096L16.413 8.24833H20.2065H24L23.9843 7.41096L23.9685 6.5736L23.6265 6.29821C23.2237 5.97386 22.8432 5.77978 22.3748 5.65959C21.9003 5.53793 18.4774 5.53912 18.0237 5.66113ZM1.539 10.6702C1.539 10.6871 2.21171 11.43 3.03399 12.3213L4.52893 13.9416L11.9972 13.9395L19.4655 13.9373L20.805 12.4841C21.5417 11.6849 22.2175 10.9429 22.3068 10.8352L22.469 10.6395H12.004C6.24828 10.6395 1.539 10.6533 1.539 10.6702ZM5.28458 14.7529C5.34916 14.8234 6.39243 15.9565 7.60299 17.2711L9.80399 19.6612V22.8424C9.80399 25.3622 9.81881 26.0186 9.87524 25.9996C9.91446 25.9864 10.9015 25.6827 12.0688 25.3246L14.1911 24.6735L14.1921 22.1594L14.193 19.6453L16.4587 17.1879C17.7049 15.8365 18.733 14.7069 18.7435 14.6778C18.7551 14.6453 16.1285 14.6248 11.9648 14.6248H5.1671L5.28458 14.7529Z" fill="#5B93FF" />
                                    </svg>
                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.usedOems ?? ""}</b></h3>
                                    <h6>Used OEM</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#8AD14D1a", padding: '19px 15px' }}>
                                    <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14.42 11.3867C16.695 12.1567 18.6667 13.4167 18.6667 15.1667V21H0V15.1667C0 13.4167 1.97167 12.1567 4.25833 11.3867L4.98167 12.8333L5.25 13.4167C3.5 13.9533 2.21667 14.7233 2.21667 15.1667V18.7833H7.14L8.16667 12.8683L7.07 10.675C7.79333 10.5933 8.55167 10.535 9.33333 10.535C10.115 10.535 10.8733 10.5933 11.5967 10.675L10.5 12.8683L11.5267 18.7833H16.45V15.1667C16.45 14.7233 15.1667 13.9533 13.4167 13.4167L13.685 12.8333L14.42 11.3867ZM9.33333 2.33333C8.05 2.33333 7 3.38333 7 4.66667C7 5.95 8.05 7 9.33333 7C10.6167 7 11.6667 5.95 11.6667 4.66667C11.6667 3.38333 10.6167 2.33333 9.33333 2.33333ZM9.33333 9.33333C6.755 9.33333 4.66667 7.245 4.66667 4.66667C4.66667 2.08833 6.755 0 9.33333 0C11.9117 0 14 2.08833 14 4.66667C14 7.245 11.9117 9.33333 9.33333 9.33333Z" fill="#54832B" />
                                    </svg>


                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.assignedDealers ?? ""}</b></h3>
                                    <h6>Assigned Dealers</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-4 col-md-6 col-xs-12">
                            <div className="topTabs">
                                <div className='customcircle' style={{ background: "#FF81581a", padding: '19px 15px' }}>
                                    <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.1346 7.46375C17.975 7.46375 19.5583 5.82042 19.5583 3.68042C19.5583 1.56625 17.9667 0 16.1346 0C14.3029 0 12.7108 1.60042 12.7108 3.6975C12.7108 5.82042 14.2942 7.46375 16.1346 7.46375ZM6.2825 7.66083C7.87458 7.66083 9.26167 6.2225 9.26167 4.365C9.26167 2.525 7.86583 1.16375 6.2825 1.16375C4.69083 1.16375 3.28667 2.55917 3.29542 4.3825C3.29542 6.2225 4.68208 7.66083 6.28292 7.66083M1.50667 15.39H8.01167C7.12167 14.0975 8.20875 11.4954 10.0492 10.0746C9.09917 9.44125 7.87458 8.97042 6.27417 8.97042C2.41375 8.97 0 11.82 0 14.1912C0 14.9621 0.427917 15.39 1.50667 15.39ZM10.7508 15.39H21.51C22.8538 15.39 23.3333 15.0046 23.3333 14.2513C23.3333 12.0429 20.5683 8.99583 16.1262 8.99583C11.6925 8.99583 8.9275 12.0429 8.9275 14.2517C8.9275 15.0046 9.40667 15.39 10.7508 15.39Z" fill="#FF8158" />
                                    </svg>


                                </div>
                                <div className='right-text'>
                                    <h3><b>{StatsData?.unassignedDealers ?? ""}</b></h3>
                                    <h6>Unassigned Dealers</h6>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="row">

                        <div className="col-xs-12" >
                            <div className='graphcards'>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                    <h5>OEM-Dealer Assignment Table</h5>
                                    <button className='btn btn-primary' style={{
                                        padding: '5px',
                                        color: " rgb(43, 120, 255)",
                                        border: "1px solid rgb(43, 120, 255)",
                                        backgroundColor: "rgb(255, 255, 255)",

                                        borderRadius: "5px"
                                    }} onClick={() => handleDownload()}>Download</button>
                                </div>
                                <div className="tablecard custom ">
                                    <div className='table-responsive'>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th><i class="fa fa-info-circle" aria-hidden="true"></i></th>
                                                    <th>OEM ID</th>
                                                    {/* <th>OEM Name</th> */}
                                                    {/* <th>Model</th> */}
                                                    <th>Vehicle Type</th>
                                                    <th>Make</th>
                                                    <th>Make Class</th>
                                                    <th>Variant</th>
                                                    <th>Dealer Assigned</th>

                                                    {/* <th>Category</th>
                                                    <th>Segment</th> */}
                                                    <th>Count of OEM used by Leads</th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    dealersData?.length > 0 ? dealersData?.map((val, id) => {
                                                        return (
                                                            <tr key={id}>
                                                                <td><i class="fa fa-info-circle" aria-hidden="true" onClick={() => handleInfoPopup(true, val)}></i></td>
                                                                <td>{val?.oemId || "-"}</td>
                                                                {/* <td>{val?.oemName || "-"}</td> */}
                                                                {/* <td>{val?.model || "-"}</td> */}
                                                                <td>{val?.vehicleType || "-"}</td>
                                                                <td>{val?.make || "-"}</td>
                                                                <td>{val?.makeClass ?? "-"}</td>
                                                                <td>{val?.variant ?? "-"}</td>
                                                                <td>{val?.dealerAssigned || "0"}</td>
                                                                {/* <td>{val?.category ?? "-"}</td>
                                                                <td>{val?.segment ?? "-"}</td> */}
                                                                <td>{val?.countOfOemUsedByLeads ?? "0"}</td>

                                                            </tr>
                                                        )
                                                    })
                                                        : ''}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'end', marginTop: '15px' }}>
                                        <Pagination
                                            count={Math.ceil(dealersDataItems)}
                                            page={currentPage + 1}
                                            onChange={handlePageChange}
                                            color="primary"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginBottom: '20px' }}>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Dealer Status Breakdown</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart width={400} height={400}>
                                            <Pie
                                                dataKey="value"
                                                data={PieData}
                                                cx="50%"
                                                cy="50%"
                                                outerRadius={80}
                                                label

                                            >
                                                {PieData?.length > 0 && PieData?.map((entry, index) => (
                                                    <Cell
                                                        key={`cell-${index}`}
                                                        fill={["#01647F", "#FF8158"][index % 2]}
                                                    />
                                                ))}
                                            </Pie>
                                            <Tooltip />
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Unit used By Vehicle Type</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart
                                            width={500}
                                            height={300}
                                            data={vehicleTypeList}
                                            barSize={30}
                                            margin={{
                                                top: 15,
                                                right: 15,
                                                left: 20,
                                                bottom: 10,
                                            }}
                                        >
                                            <CartesianGrid vertical={false} />
                                            <XAxis dataKey="vehicleType" tickLine={false} axisLine={false} tick={{
                                                // angle: -20,
                                                // textAnchor: 'end',
                                                fontSize: 9
                                            }} />
                                            <YAxis axisLine={false} tickLine={false} />
                                            <Bar dataKey="count" fill="#6FA6B5" />
                                            <Tooltip />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <div className='graphcards'>
                                <h5>Sales over Time</h5>
                                <hr />
                                <div className="chartDiv">
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={salesOverTimeList}
                                            barSize={30}
                                            margin={{
                                                top: 15,
                                                right: 15,
                                                left: 20,
                                                bottom: 10,
                                            }}
                                        >
                                            <CartesianGrid vertical={false} />
                                            <XAxis dataKey="month" tickLine={false} axisLine={false} tick={{
                                                // angle: -20,
                                                // textAnchor: 'end',
                                                fontSize: 9
                                            }} />
                                            <YAxis axisLine={false} tickLine={false} />
                                            <Line dataKey="sales" fill="#014C60" />
                                            <Tooltip />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {
                    infoPopup?.show ?
                        <div className="background-blur">

                            <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '700px' }}>
                                <i onClick={() => handleInfoPopup(false, {})} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                <div className="row from-group">
                                    <div className="col-xs-12" style={{ padding: '10px' }}>
                                        <h4 className="text-center" style={{ marginTop: '10px' }}>OEM Details</h4>
                                    </div>
                                </div>
                                <div className="row from-group" style={{ marginTop: '10px' }}>

                                    <div className="col-sm-4 col-xs-12">
                                        <label style={{ fontWeight: '500' }}>OEM Id</label>
                                        <h6 style={{ marginTop: '0' }}>{infoTableData?.oemId ?? "-"}</h6>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label style={{ fontWeight: '500' }}>Make</label>
                                        <h6 style={{ marginTop: '0' }}>{infoTableData?.make ?? "-"}</h6>
                                    </div>
                                    {/* <div className="col-sm-4 col-xs-12">
                                        <label style={{ fontWeight: '500' }}>Model </label>
                                        <h6 style={{ marginTop: '0' }}>{infoTableData?.model ?? "-"}</h6>
                                    </div> */}
                                    <div className="col-sm-4 col-xs-12">
                                        <label style={{ fontWeight: '500' }}>Vehicle Type</label>
                                        <h6 style={{ marginTop: '0' }}>{infoTableData?.vehicleType ?? "-"}</h6>
                                    </div>

                                </div>
                                <div className="row from-group" style={{ marginTop: '10px' }}>

                                    <div className="col-sm-4 col-xs-12">
                                        <label style={{ fontWeight: '500' }}>Class </label>
                                        <h6 style={{ marginTop: '0' }}>{infoTableData?.oemClass ?? "-"}</h6>
                                    </div>
                                    <div className="col-sm-4 col-xs-12">
                                        <label style={{ fontWeight: '500' }}>Variant </label>
                                        <h6 style={{ marginTop: '0' }}>{infoTableData?.variant ?? "-"}</h6>
                                    </div>
                                </div>

                                <div className="row from-group" style={{ marginTop: '10px' }}>
                                    <div className="col-xs-12">
                                        <div className="graphcards" style={{ margin: '0', padding: '0' }}>
                                            <h5>Assign Dealers</h5>
                                            <div className="tablecard custom table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                                <table className='table'>
                                                    <thead>
                                                        <tr>
                                                            <th>Dealer Name</th>
                                                            <th>Usage</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            infoTableData?.dealerDTO?.length > 0 ? infoTableData?.dealerDTO?.map((value, id) => {
                                                                return (
                                                                    <tr key={id}>
                                                                        <td>{value?.dealerName || "-"}</td>
                                                                        <td>{value?.usage || "-"}</td>
                                                                    </tr>
                                                                )
                                                            })
                                                                : ""}

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        : ""}
            </div>

        </>
    )
}
